import type { Rename } from './types.js';
import { StudioError } from '#~/error/index.js';
import { toIdFromHex, wrapApiCall } from '#~/api/index.js';
import { AgentRegistryUpdate } from '@tryiris-ai/mailroom-helper/agentRegistry';
import { nats } from '#~/nats/index.js';

/**
 * Rename the specified agent.
 *
 * @param agentId - The ID of the agent to be renamed.
 * @param _nextName - The new name for the agent.
 */
export const rename: Rename = async (agentId, _nextName, token) => {
  try {
    const idBytes = toIdFromHex(agentId)!;
    await wrapApiCall(async () =>
      AgentRegistryUpdate.request(nats.cloudConnection(), { id: idBytes, token, name: _nextName })
    );
  } catch (cause) {
    throw new StudioError(`Unable to rename bridge: ${agentId}`, { cause });
  }
};
